import { createFileRoute } from '@tanstack/react-router';

import { AUTH_MODULE_PATHS } from 'shared/common/consts/paths';
import { logout } from 'shared/queries/authenticationApi';

import { clientModules } from '@/clientModules';

export const Route = createFileRoute('/unauthorized')({
  component: UnauthorizedPage
});

function UnauthorizedPage() {
  return <clientModules.authentication.UnauthorizedPage onCallLogoutEndpoint={logout} paths={AUTH_MODULE_PATHS} />;
}
